/**
 * A replacement for setTimeout that supports delays longer than 2147483647ms (~24.8 days).
 */
export const setLongTimeout = (
  callback: () => void,
  delay: number
): VoidFunction => {
  const MAX_DELAY = 2147483647; // Maximum delay for setTimeout (2^31 - 1)

  let timeoutId: ReturnType<typeof setTimeout> | null = null;
  let remaining = delay;

  const run = () => {
    if (remaining <= MAX_DELAY) {
      timeoutId = setTimeout(callback, remaining);
    } else {
      timeoutId = setTimeout(() => {
        remaining -= MAX_DELAY;
        run();
      }, MAX_DELAY);
    }
  };

  run();

  // Return a cancel function
  return () => {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }
  };
};
